var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.02344 17.0234C1.02344 14.0234 5.02344 14.0234 7.02344 12.0234C8.02344 11.0234 5.02344 11.0234 5.02344 6.02344C5.02344 2.69044 6.35644 1.02344 9.02344 1.02344C11.6904 1.02344 13.0234 2.69044 13.0234 6.02344C13.0234 11.0234 10.0234 11.0234 11.0234 12.0234C13.0234 14.0234 17.0234 14.0234 17.0234 17.0234",
    stroke: "#178477",
    strokeWidth: 2.04709,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiconUser);
export default __webpack_public_path__ + "static/media/micon-user.3c08eda725579484280f1d8032241c8f.svg";
export { ForwardRef as ReactComponent };